/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ENVIRONMENT_CONFIG, Environment } from '@common/environment-shared';
import { Injectable, inject } from '@angular/core';
import { HttpService, ResourceFactory, ResourceUri } from '@ngxp/rest';
import { Observable } from 'rxjs';
import { ApiRootLinkRel } from './api-root.linkrel';
import { ApiRootResource, DownloadTokenRequest } from './api-root.model';

@Injectable()
export class ApiRootRepository {
  private readonly httpService = inject(HttpService);
  private readonly resourceFactory = inject(ResourceFactory);
  private readonly environmentConfig = inject<Environment>(ENVIRONMENT_CONFIG);

  public loadApiRoot(): Observable<ApiRootResource> {
    return this.httpService.get(this.environmentConfig.remoteHost);
  }

  public downloadToken(apiRootResource: ApiRootResource, fileUri: ResourceUri): Observable<any> {
    return this.resourceFactory
      .from(apiRootResource)
      .post(ApiRootLinkRel.DOWNLOAD_TOKEN, <DownloadTokenRequest>{ fileId: fileUri });
  }
}
